module.exports = __webpack_public_path__ + "static/CalibreWeb-Black-01f9312e7a346078bc8d5c7a2561bb6c.eot";